import { Divider, Typography } from "@mui/material";
import CustomIconButton from "../../../../ui library/components/buttons/CustomIconButton";
import { ArrowForwardIos } from "@mui/icons-material";
import React from "react";

export function FilterDrawer({toggleFilterMenu, setToggleFilterMenu, children}){
  return(
     
          <div
            className="flex flex-col w-[450px] h-full"
            style={{
              position: 'absolute',
              zIndex: '1000',
              backgroundColor: '#fff',
              borderRight: '1px solid #ececec',
              boxShadow: '4px 0 6px -2px rgba(0, 0, 0, 0.2)',
              borderRadius: '10px 0px 0px 10px'
            }}
          >
            <div className="flex flex-row justify-between items-center">
              <Typography className="text-lg font-bold p-2 pl-4">
                Filter:
              </Typography>
              <CustomIconButton
                tooltipText="Hide Filter Menu"
                classes="rotate-180 p-2"
                handleOnClick={() => setToggleFilterMenu(!toggleFilterMenu)}
                iconVisible={true}
                CustomIcon={<ArrowForwardIos className="text-sky-600"/>}
              />
            </div>
            <Divider></Divider>
             {React.Children.map(children, (child) => React.cloneElement(child))}
            
          </div>
        
  )
}